// Mock content for The Owner's Mind — front-end only for now.

export const SUBSTACK_URL = "https://substack.com/@theownersmind";

export const NAV_LINKS = [
  { label: "Ideas", href: "#ideas" },
  { label: "About", href: "#about" },
  { label: "The Owner's Gift", href: "/owners-gift" },
  { label: "FAQ", href: "#faq" },
];

export const MARQUEE_TEXT = "Build the life you want";

// Category chips (Kinhive-style "+ LABEL" list)
export const CATEGORIES = [
  "CLARITY",
  "DECISIONS",
  "AGENCY",
  "OPTIONS",
  "ACTION",
  "PROGRESS",
];

// Founder short intro paragraph shown near the chips section
export const FOUNDER_INTRO =
  "Created by Cynthia D after twenty years observing founders, investors, executives, athletes, and other highly accomplished people, The Owner's Mind exists to translate what actually works — into ideas everyday people can use.";

// 3 pillar feature cards (Kinhive-style)
export const PILLARS = [
  {
    id: "clarity",
    icon: "compass",
    title: "Real Clarity",
    body: "Get honest about what you actually want — not what you were told to want. Ownership begins the moment you stop drifting.",
  },
  {
    id: "decisions",
    icon: "scale",
    title: "Better Decisions",
    body: "Borrow the questions high achievers ask about time, risk, opportunity, and setbacks — and apply them to the choices in front of you.",
  },
  {
    id: "action",
    icon: "footprints",
    title: "Quiet Momentum",
    body: "Move from planning to doing. Small, deliberate steps that compound into a life that feels right for you.",
  },
];

// "Not a directory" style features grid
export const NOT_FEATURES = [
  {
    title: "Essays & Letters",
    body: "Considered writing on ownership, decisions, and building a life you actually want — delivered when there's something worth sending.",
    href: "#ideas",
  },
  {
    title: "Practical Frameworks",
    body: "Simple, borrowable tools for thinking through goals, risk, transitions, and the trade-offs behind every meaningful choice.",
    href: "#ideas",
  },
  {
    title: "The Owner's Gift",
    body: "A quarterly $1,000 gift to someone taking real action on something they want to build, learn, change, or create.",
    href: "#gift",
  },
];

// Stats block (borrowed research on goal-setting and agency)
export const STATS = [
  {
    figure: "42%",
    label: "More likely to achieve goals when written down and reviewed regularly",
    source: "Dr. Gail Matthews, Dominican University",
  },
  {
    figure: "3x",
    label: "Higher follow-through when a goal is shared with someone who checks in",
    source: "American Society of Training & Development",
  },
  {
    figure: "92%",
    label: "Of New Year's resolutions fail without a written plan and a review cadence",
    source: "University of Scranton",
  },
];

// Ways to engage (Kinhive's pricing block, adapted)
export const ENGAGE = [
  {
    name: "Read",
    price: "Free",
    priceNote: "newsletter",
    subtitle: "For anyone curious about ownership as a way of thinking.",
    features: [
      "Essays and letters delivered when they're worth reading",
      "Occasional practical frameworks and reflection prompts",
      "Full archive access",
    ],
    cta: "Subscribe",
    highlight: false,
  },
  {
    name: "Reflect",
    price: "Coming",
    priceNote: "soon",
    subtitle: "For readers who want to go deeper than the essays alone.",
    features: [
      "Everything in Read",
      "Longer letters and behind-the-scenes notes",
      "Guided prompts for setting and reviewing goals",
      "Reader Q&A threads",
    ],
    cta: "Join the waitlist",
    highlight: true,
  },
  {
    name: "Apply",
    price: "$1,000",
    priceNote: "quarterly gift",
    subtitle: "For someone actively taking action on something that matters.",
    features: [
      "Open to any reader taking real action",
      "Share what you're working on and what's next",
      "One recipient chosen every quarter",
      "Celebrated across the community",
    ],
    cta: "Learn about the gift",
    highlight: false,
  },
];

export const TILES = [
  { kind: "text", text: "I don't", emphasis: "know", tail: "what I want.", bg: "#B995EE", fg: "#41232E" },
  { kind: "photo", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_mindful-owner/artifacts/tn6fm6sj_Screenshot%202026-02-08%20at%208.37.06%E2%80%AFAM.png", alt: "A quiet home workspace" },
  { kind: "text", text: "I feel", emphasis: "stuck.", tail: "", bg: "#605F26", fg: "#FFFDF6" },
  { kind: "photo", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_mindful-owner/artifacts/2knhq9cg_827fa65419e24f0edb07029f2a48fc01.jpg", alt: "Sharing ideas in a room" },
  { kind: "photo", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_mindful-owner/artifacts/m8yhjpzt_4532f61a10e62ce2f2fb73bc89c54341.jpg", alt: "Sunrise practice by the sea" },
  { kind: "text", text: "Where do I", emphasis: "begin?", tail: "", bg: "#41232E", fg: "#D8D355" },
  { kind: "photo", image: "https://customer-assets-wrfwihn1.emergentagent.net/job_mindful-owner/artifacts/wesudv1p_479efc6f990dd0aa4ff042b441174632.jpg", alt: "On the way" },
  { kind: "text", text: "Am I doing", emphasis: "enough?", tail: "", bg: "#D8D355", fg: "#41232E" },
];

export const PRODUCTS = [
  {
    title: "The Owner's Blueprint",
    format: "Digital Workbook",
    price: "$29",
    blurb: "A guided workbook for defining what you actually want and mapping the first steps toward it.",
    image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?auto=format&fit=crop&w=1200&q=80",
    accent: "#D8D355",
  },
  {
    title: "Better Decisions",
    format: "Mini Course",
    price: "$79",
    blurb: "A five-part video course on borrowing the questions high achievers actually ask before choosing.",
    image: "https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=1200&q=80",
    accent: "#B995EE",
  },
  {
    title: "Quiet Momentum",
    format: "Audio Series",
    price: "$19",
    blurb: "Short audio letters for the in-between moments \u2014 practical, calm, and easy to return to.",
    image: "https://images.unsplash.com/photo-1490718720478-364a07a997cd?auto=format&fit=crop&w=1200&q=80",
    accent: "#C1D3D9",
  },
];

export const IDEAS = [
  {
    title: "What an Owner Actually Owns",
    excerpt: "Ownership is psychological, not occupational. Here's what changes when you start seeing your life as something you shape.",
    tag: "Foundations",
    image: "https://images.unsplash.com/photo-1529047033375-f402d3da24ca?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "The Questions High Achievers Ask",
    excerpt: "After twenty years in rooms with founders, investors, and operators, a handful of questions come up again and again. They are borrowable.",
    tag: "Decisions",
    image: "https://images.unsplash.com/photo-1554325103-6985922f9a41?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "How to Change Direction Without Blowing Up Your Life",
    excerpt: "Big shifts don't require dramatic exits. A quieter, more deliberate way to move toward what actually fits.",
    tag: "Transitions",
    image: "https://images.unsplash.com/photo-1573507811472-909cd17e834d?auto=format&fit=crop&w=1200&q=80",
  },
];

export const FOUNDER_IMG = "https://customer-assets-wrfwihn1.emergentagent.net/job_mindful-owner/artifacts/l9wurmg0_Background%20Color%20Change.png";

export const FAQS = [
  {
    q: "What is The Owner\u2019s Mind?",
    a: "A place to share what I\u2019ve learned about setting goals, making decisions, taking action and creating more ownership over your life.",
  },
  {
    q: "Who is The Owner\u2019s Mind for?",
    a: "Anyone working toward something that matters to them \u2014 personally, professionally, creatively, financially or otherwise.",
  },
  {
    q: "Do I need to own a business to be an \u201cOwner\u201d?",
    a: "Not at all. Ownership here means taking agency over your life \u2014 deciding what you want and taking responsibility for what you can do next.",
  },
  {
    q: "What will I find here?",
    a: "Observations, ideas and practical frameworks gathered from 20+ years of watching how people set goals, solve problems, make decisions and get where they want to go.",
  },
  {
    q: "What is The Owner\u2019s Gift?",
    a: "Every quarter, I give $1,000 to someone investing in themselves and taking action toward something that matters to them.",
  },
  {
    q: "Is The Owner\u2019s Mind a coaching program?",
    a: "No. Think of it more as part mentorship, part community \u2014 a place to learn, think, apply what\u2019s useful and connect with other people building their own path.",
  },
  {
    q: "How do I follow along?",
    a: "Join The Owner\u2019s Mind to get new writing, ideas and updates by email and be part of what we\u2019re building.",
  },
];

export const GIFT = {
  amount: "$1,000",
  cadence: "Quarterly",
  headline: "The Owner's Gift",
  sub: "A quarterly gift for someone taking real action on something that matters to them.",
};
